module.exports = __webpack_public_path__ + "images/logo.13bb120.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/logo.png
// module id = 129
// module chunks = 0